// Caps Horizon's infinite scroll on collection and search grids: after 50 products it stops loading on
// scroll and shows a "Load more" button; each click allows another 50. Horizon loads the next page when its
// [ref="viewMoreNext"] marker scrolls into view, so hiding the marker pauses it and showing it resumes.
// Grids are re-rendered by filters and sorting, so new ones are picked up as they appear.
(function () {
  var STEP = 50;

  function setup(marker) {
    if (marker.dataset.lytesLoadMore) return;
    var grid = marker.parentElement && marker.parentElement.querySelector('[ref="grid"]');
    if (!grid) return;
    marker.dataset.lytesLoadMore = 'true';

    var total = Number(grid.dataset.lytesTotal) || 0;
    var limit = STEP;
    var wrap = null;

    function count() {
      return grid.querySelectorAll(':scope > li').length;
    }

    function update() {
      var shown = count();
      var more = total ? shown < total : true;
      var paused = more && shown >= limit;
      marker.style.display = paused ? 'none' : '';
      if (paused && !wrap) {
        wrap = document.createElement('div');
        wrap.className = 'lytes-load-more';
        var note = document.createElement('p');
        note.className = 'lytes-load-more__note';
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'button lytes-load-more__button';
        button.textContent = 'Load more products';
        button.addEventListener('click', function () {
          limit = count() + STEP;
          update();
        });
        wrap.append(note, button);
        marker.after(wrap);
      }
      if (wrap) {
        wrap.hidden = !paused;
        if (paused) wrap.firstChild.textContent = total ? 'Showing ' + shown + ' of ' + total + ' products' : '';
      }
    }

    new MutationObserver(update).observe(grid, { childList: true });
    update();
  }

  function scan() {
    document.querySelectorAll('[ref="viewMoreNext"]').forEach(setup);
  }

  function start() {
    scan();
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
